import React from "react";
import { TextField } from "@mui/material";
import xplanLabels from "../../util/XplanLabels";
import HistoryLogElement from "./HistoryLogElement";
import GroupAllUsers from "../FieldTags/GroupAllUsers";

const newPlan = window.location.pathname === "/xplans/new";

const SmrStatusComment = ({ smrStatusComment, handleChange, xplans }) => {

    return (
        <div id="smrStatusComment" className="planField">
            <GroupAllUsers />
            <TextField
                name="smrStatusComment"
                label={xplanLabels.smrStatusComment}
                InputLabelProps={{ shrink: true }}
                type="text"
                value={smrStatusComment ? smrStatusComment  : ""}
                onChange={(e) => handleChange("smrStatusComment", e.target.value)}
                multiline
                minRows={1}
                className="fullLength"
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"smrStatusComment"} />}
        </div>
    );
};

export default SmrStatusComment;
